import React from 'react';
import web from './web.png';
import app from './app.png';
import lap from './lap.jpg';
import './Products.css';
import Slide from 'react-reveal/Slide';


function Products() {
    return (
        <div>
            <div className='products'>
                <div className='web'>
                        <Slide right>
                            <img className='webimg' src={web} />
                        </Slide>
                    <h1 className='webtext'>Custom Websites</h1>
                </div>
                <div className='app'>
                    <h1 className='apptext'>Custom Apps</h1>
                    <Slide right>
                            <img className='appimg' src={app} />
                        </Slide>
                </div>
                <div className='laptops'>
                        <Slide right>
                            <img className="lapImg" src={lap} />
                        </Slide>
                    <h1 className="laptext">VLaptop</h1>
                </div>
            </div>
        </div>
    )
}

export default Products
